import React from 'react'
import { HeadCard } from '../../structure/card/HeadCard'
import { DatatableNameImpuesto } from './DatatableNameImpuesto'

export const NameImpuestoPage = () => {
    return (
        <div className="content-wrapper">
            <HeadCard titulo="NOMBRE IMPUESTO" />
            <section className="content">
                <div className="card">
                    <div className="card-header">
                    </div>

                    <DatatableNameImpuesto />

                </div>
            </section>
        </div>
    )
}
